import { render, staticRenderFns } from "./AddNewAccount.vue?vue&type=template&id=890ffd62&"
import script from "./AddNewAccount.vue?vue&type=script&lang=js&"
export * from "./AddNewAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports